export const ACTION_ADD_SITE_SEO_DATA = 'ACTION_ADD_SITE_SEO_DATA';
export const ACTION_ADD_SITE_SEO_TRANSLATIONS = 'ACTION_ADD_SITE_SEO_TRANSLATIONS';

export const ACTION_DELETE_SEO_TRANSLATIONS__REQUEST = 'ACTION_DELETE_SEO_TRANSLATIONS__REQUEST';
export const ACTION_DELETE_SEO_TRANSLATIONS__SUCCESS = 'ACTION_DELETE_SEO_TRANSLATIONS__SUCCESS';
export const ACTION_DELETE_SEO_TRANSLATIONS__FAIL = 'ACTION_DELETE_SEO_TRANSLATIONS__FAIL';

export const ACTION_DELETE_SEO_TRANSLATION__REQUEST = 'ACTION_DELETE_SEO_TRANSLATION__REQUEST';
export const ACTION_DELETE_SEO_TRANSLATION__SUCCESS = 'ACTION_DELETE_SEO_TRANSLATION__SUCCESS';
export const ACTION_DELETE_SEO_TRANSLATION__FAIL = 'ACTION_DELETE_SEO_TRANSLATION__FAIL';

export const ACTION_DELETE_SEO_TRANSLATIONS_BY_LANG__REQUEST = 'ACTION_DELETE_SEO_TRANSLATIONS_BY_LANG__REQUEST';
export const ACTION_DELETE_SEO_TRANSLATIONS_BY_LANG__SUCCESS = 'ACTION_DELETE_SEO_TRANSLATIONS_BY_LANG__SUCCESS';
export const ACTION_DELETE_SEO_TRANSLATIONS_BY_LANG__FAIL = 'ACTION_DELETE_SEO_TRANSLATIONS_BY_LANG__FAIL';

export const ACTION_EDIT_SEO_TRANSLATION__REQUEST = 'ACTION_EDIT_SEO_TRANSLATION__REQUEST';
export const ACTION_EDIT_SEO_TRANSLATION__SUCCESS = 'ACTION_EDIT_SEO_TRANSLATION__SUCCESS';
export const ACTION_EDIT_SEO_TRANSLATION__FAIL = 'ACTION_EDIT_SEO_TRANSLATION__FAIL';

export const ACTION_CREATE_CUSTOM_TAG__REQUEST = 'ACTION_CREATE_CUSTOM_TAG__REQUEST';
export const ACTION_CREATE_CUSTOM_TAG__SUCCESS = 'ACTION_CREATE_CUSTOM_TAG__SUCCESS';
export const ACTION_CREATE_CUSTOM_TAG__FAIL = 'ACTION_CREATE_CUSTOM_TAG__FAIL';

export const ACTION_DELETE_CUSTOM_TAG__REQUEST = 'ACTION_DELETE_CUSTOM_TAG__REQUEST';
export const ACTION_DELETE_CUSTOM_TAG__SUCCESS = 'ACTION_DELETE_CUSTOM_TAG__SUCCESS';
export const ACTION_DELETE_CUSTOM_TAG__FAIL = 'ACTION_DELETE_CUSTOM_TAG__FAIL';

export const ACTION_ADD_CUSTOM_TAGS = 'ACTION_ADD_CUSTOM_TAGS';
